import { ViewModel,View, ObservableArray } from "binder"
import  { AutomatedPriceUpdatingView } from "./automatedPriceUpdating-view"
import { Enum, IEnumTranslator, utilities } from "uicomponents";
import { Converters } from "src/converters";
import moment from "moment";
import { ServerConnection } from "src/server/serverConnection";
import { ExcelExporter, stringIsNullOrEmpty } from "src/common/utilities";
import { PricingPerCarModelViewModel } from "../pricingPerCarModel/pricingPerCarModel-viewModel";

export class AutomatedPriceUpdatingViewModel extends ViewModel{
    constructor(parentViewModel: PricingPerCarModelViewModel) {
        super(parentViewModel);
        this.isAdmin = true;
        this._parent = parentViewModel;
        this.prices = ObservableArray.create<singleProductPrice>();

        this.huntEnumProvider = new indexEnumProvider();
        this.saleEnumProvider = new indexEnumProvider();
        this.priceRelation = new priceRelation();
        this.purchaseEnumProvider = new indexEnumProvider();
        this.calculationTypeEnumProvider = new calculationTypeProvider();
        this.reportDay = moment.utc().hour(5).minute(0).second(0);
    }
    GetDefaultView(): View <ViewModel> {
        return new AutomatedPriceUpdatingView();
    }
    public getTypeId(): string {
        return "VM-93472F8C-1A37-432C-A620-989B9BE0A961"
    }

    private _parent: PricingPerCarModelViewModel;
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set prices(v: ObservableArray<singleProductPrice>) { this._prices = v; } public get prices(): ObservableArray<singleProductPrice> { return this._prices;} private _prices: ObservableArray<singleProductPrice>;
    public set currentAllProductPriceSum(v: number) { this._currentAllProductPriceSum = v; } public get currentAllProductPriceSum(): number { return this._currentAllProductPriceSum;} private _currentAllProductPriceSum: number;
    public set calculatedPriceSum(v: number) { this._calculatedPriceSum = v; } public get calculatedPriceSum(): number { return this._calculatedPriceSum;} private _calculatedPriceSum: number;
    public set finalPriceSum(v: number) { this._finalPriceSum = v; } public get finalPriceSum(): number { return this._finalPriceSum;} private _finalPriceSum: number;
    public set allNoSaleLockBalance(v: number) { this._allNoSaleLockBalance = v; } public get allNoSaleLockBalance(): number { return this._allNoSaleLockBalance;} private _allNoSaleLockBalance: number;
    public set allBalance(v: number) { this._allBalance = v; } public get allBalance(): number { return this._allBalance;} private _allBalance: number;
    public set allHunt(v: number) { this._allHunt = v; } public get allHunt(): number { return this._allHunt;} private _allHunt: number;
    public set allInWay(v: number) { this._allInWay = v; } public get allInWay(): number { return this._allInWay;} private _allInWay: number;
    public set allSale(v: number) { this._allSale = v; } public get allSale(): number { return this._allSale;} private _allSale: number;
    public set allCancel(v: number) { this._allCancel = v; } public get allCancel(): number { return this._allCancel;} private _allCancel: number;
    public set allReturn(v: number) { this._allReturn = v; } public get allReturn(): number { return this._allReturn;} private _allReturn: number;
    public set allMarkaziSale(v: number) { this._allMarkaziSale = v; } public get allMarkaziSale(): number { return this._allMarkaziSale;} private _allMarkaziSale: number;
    public set allMellatSale(v: number) { this._allMellatSale = v; } public get allMellatSale(): number { return this._allMellatSale;} private _allMellatSale: number;
    
    public set huntEnumProvider(v: indexEnumProvider) { this._huntEnumProvider = v; } public get huntEnumProvider(): indexEnumProvider { return this._huntEnumProvider;} private _huntEnumProvider: indexEnumProvider;
    public set saleEnumProvider(v: indexEnumProvider) { this._saleEnumProvider = v; } public get saleEnumProvider(): indexEnumProvider { return this._saleEnumProvider;} private _saleEnumProvider: indexEnumProvider;
    public set purchaseEnumProvider(v: indexEnumProvider) { this._purchaseEnumProvider = v; } public get purchaseEnumProvider(): indexEnumProvider { return this._purchaseEnumProvider;} private _purchaseEnumProvider: indexEnumProvider;
    public set calculationTypeEnumProvider(v: calculationTypeProvider) { this._calculationTypeEnumProvider = v; } public get calculationTypeEnumProvider(): calculationTypeProvider { return this._calculationTypeEnumProvider;} private _calculationTypeEnumProvider: calculationTypeProvider;
    
    
    public set isAdmin(v: boolean) { this._isAdmin = v; } public get isAdmin(): boolean { return this._isAdmin;} private _isAdmin: boolean;
    public set reportDay(v: moment.Moment) { this._reportDay = v; } public get reportDay(): moment.Moment { return this._reportDay;} private _reportDay: moment.Moment;
    public set dollarPrice(v: number) { this._dollarPrice = v; } public get dollarPrice(): number { return this._dollarPrice;} private _dollarPrice: number;
    public set priceRelation(v: priceRelation) { this._priceRelation = v; } public get priceRelation(): priceRelation { return this._priceRelation;} private _priceRelation: priceRelation;
    
    public set car(v: string) { this._car = v; } public get car(): string { return this._car;} private _car: string;
    public set carName(v: string) { this._carName = v; } public get carName(): string { return this._carName;} private _carName: string;
    public set tabName(v: string) { this._tabName = v; } public get tabName(): string { return this._tabName; } private _tabName: string;
    
    closePopup() {
        this._parent.closePopup();
    }

    showUpdateDollarPrices(){
        let pricesVm = new dollarFeeSetting(this);
        this._parent.showPopup2(pricesVm);
    }
    showPriceSummary(){
        let pricesVm = new priceSummaryHistory(this);
        this._parent.showPopup2(pricesVm);
    }
    async updatePrices(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PricingServices/UpdateProductPricesFromProcess',{
                Prices:this.prices.map(x=>{
                    return {
                        ProductId:x.productId,
                        PriceAmount:x.finalPrice,
                        From:null,
                        ApproachType:x.calculationType,
                        CustomPercentage:x.customBenefitAmount
                    };
                }),
                FinalTotalPrice:this.finalPriceSum,
                FinalCalculablePrice:this.calculatedPriceSum,
                FinalCurrentPrice:this.currentAllProductPriceSum,
                ProductCount:this.allBalance,
                DollarPrice:this.dollarPrice,
                ForDate:this.reportDay.clone().hour(5).minute(0).second(0)
            });
            if(result.IsSuccessful)
                alert('عملیات با موفقیت انجام شد.');
            else
                alert('خطا در انجام عملیات')
        } catch (ex) {
            alert('خطا در انجام عملیات')
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async refreshUpdateCustomBenefits(){
        await this.refresh(true);
    }

    async refresh(shallUpdateCustomBenefits:boolean = false){
        try {
            this.isLoading = true;
            this.prices.clear();
            let result =await ServerConnection.callServer('Complex/PricingServices/GetPricingReport',{
                Time:this.reportDay.clone().hour(5).minute(0).second(0),
                CarModelId: this.car,
                ShallUpdateCustomBenefits:shallUpdateCustomBenefits
            });
            let warehouseNames = result.Warehouses.map(x=>x.Name);
            this.dollarPrice = result.DollarPrice;
            this.prices.update(...result.Prices.map(x=>{
                let r = new singleProductPrice(this);
                r.productId = x.ProductId;
                r.productNo = x.PartNo;
                r.productName = x.ProductName;
                r.pnc = x.Pnc;
                r.productIndex = x.ProductIndex;
                r.brand = x.Brand;
                r.country = x.Country;
                r.color = x.Color;
                r.car = x.CarId;
                r.carName = x.CarName;
                r.replacements = x.Replacements;
                r.carModels = x.CarModels;
                r.hasCarModels = !stringIsNullOrEmpty(r.carModels);
                r.hasReplacements = !stringIsNullOrEmpty(r.replacements);
                r.balance = x.Balance;
                r.balanceMargin = x.BalanceMargin;
                r.noSaleLockAmount = x.NoSaleLockBalance;
                r.mellatNoSaleLockAmount = x.MellatNoSaleLockBalance;
                r.parandNoSaleLockAmount = x.ParandNoSaleLockBalance;
                r.lastSalePrice = x.LastSalePrice;
                r.fee = x.Fee;
                r.huntCount = x.HuntCount;
                r.purchaseAmount = x.BuyCount;
                r.inWay = x.InWayCount;
                r.currentDollarPrice = result.DollarPrice;
                r.setDollarPrice = x.DollarSetPrice;
                r.setPriceDate = moment.utc(x.SetPriceDate);
                r.competitorPrice = x.LastCompetitorInquiryPrice;
                r.calculablePrice = x.CalculablePrice;
                r.optimalTransferAmount = x.OptimalTransferAmount;
                r.mellatSoldAmount = x.MellatSoldAmount;
                r.markaziSoldAmount = x.MarkaziSoldAmount;
                r.saleAmount = x.SaleAmount;
                r.cancelAmount = x.CancelAmount;
                r.returnAmount = x.ReturnAmount;
                r.importImportance = x.ImportImportance;
                r.huntIndex = x.LastHuntTimeIndex;
                r.purchaseIndex = x.LastPurchaseTimeIndex;
                r.saleIndex = x.LastSaleTimeIndex;
                r.isSetPriceEditable = x.IsSetPriceEditable;
                r.isCompeting = x.IsCompeting;
                r.minImportPrice = x.MinImportPrice;
                r.minBenefitPercentage = x.MinBenefitPercentage;
                r.minBenefitModifyDate = x.MinBenefitModifyDate == null ? null : moment.utc(x.MinBenefitModifyDate);
                r.minBenefitModifier = x.MinBenefitModifier;
                r.maxImportPrice = x.MaxImportPrice;
                r.minImportPriceTime = moment.utc(x.MinImportPriceTime);
                r.maxImportPriceTime = moment.utc(x.MaxImportPriceTime);
                r.customBenefitHistory.update(...x.CustomBenefitHistory.map(q=>{
                    let res = new benefitHistory(r);
                    res.amount = q.Amount;
                    res.applier = q.ApplierName;
                    res.from = moment.utc(q.From);
                    res.until = q.Until==null ? null : moment.utc(q.Until);
                    return res;
                }))
                r.inquiryInfo.update(...x.CompetitorInfo.map(q=>{
                    let c = new inquiryInfo(r);
                    c.time = moment.utc(q.Time);
                    c.price = q.Price;
                    c.districtName = q.DistrictName;
                    c.competitorName = q.CompetitorName;
                    return c;
                }))
                r.saleHistory.update(...x.SaleHistory.map(q=>{
                    let s = new saleHistory(r);
                    s.fee = q.Price;
                    s.count = q.Count;
                    s.systemBenefitPercentage = q.BenefitPercentage;
                    s.setPrice = q.SetPrice;
                    s.dollarPrice = q.DollarPrice;
                    s.benefitPercentage = Math.round(1.2 * s.dollarPrice * s.setPrice / (1000 * s.fee)) * 1000;
                    s.time = moment.utc(q.Time);
                    return s;
                }));
                r.purchaseHistory.update(...x.PurchaseHistory.map(q=>{
                    let s = new purchaseHistory(r);
                    s.fee = q.DollarPrice;
                    s.count = q.Amount;
                    s.time = moment.utc(q.Time);
                    return s;
                }));
                r.huntInfo.update(...x.HuntInfo.map(q=>{
                    let h = new huntInfo(r);
                    h.time = moment.utc(q.Time);
                    h.count = q.Count;
                    return h;
                }));
                r.priceHistory.update(...x.PriceHistory.map(q=>{
                    let w = new priceHistory(r);
                    w.from = moment.utc(q.From);
                    w.until = q.Until==null ? null : moment.utc(q.Until);
                    w.setPrice = q.SetPrice;
                    w.updater = q.Updater;
                    return w;
                }));
                r.warehouseBalances.update(...x.WarehouseBalances.map((q,i)=>{
                    let b = new warehouseBalance(r);
                    b.balance = q;
                    b.warehouseName = warehouseNames[i];
                    return b;
                }));
                r.lastImportPrice = x.LastImportPrice;
                r.lastHuntTime = x.LastHuntTime==null?null:moment.utc(x.LastHuntTime);
                r.lastSaleTime = x.LastSaleTime==null?null:moment.utc(x.LastSaleTime);
                r.lastPurchaseTime =x.LastPurchaseTime==null ? null :moment.utc(x.LastPurchaseTime);
                r.importPrices.update(...x.ImportPrices.map(q=>{
                    let p = new ImportPrices(r);
                    p.price = q.Price;
                    p.supplierName = q.SupplierName;
                    p.time = moment.utc(q.Time);
                    return p;
                }))
                r.saleFeeList.update(...x.FeeList.map(q=>{
                    let f = new RialFee(r);
                    f.time = moment.utc(q.Time);
                    f.fee = q.Price;
                    return f;
                }));
                r.yearBalances.update(...x.YearBalances.map(q=>{
                    let w = new YearBalance(r);
                    w.year = q.Year;
                    w.balance = q.Balance;
                    return w;
                }))
                r.isSetSaved = true;
                r.isCompetingSaved = true;
                r.calculationType = x.CalculationType;
                r.finalPrice = x.FinalPrice;
                r.firstRoundCalculationType = x.FirstRoundCalculationType;
                r.firstRoundFinalPrice = x.FirstRoundFinalPrice;
                if(x.LastInquiryPrice==null){
                    r.priceRelation = 2;
                }else{
                    if(x.LastInquiryPrice>x.FinalPrice){
                        r.priceRelation = 1;
                    }else if(x.LastInquiryPrice<x.FinalPrice){
                        r.priceRelation = 0;
                    }else{
                        r.priceRelation = 2;
                    }
                }
                r.changeAmount = r.finalPrice - r.fee;
                r.changeRatio = r.fee==0 ? r.finalPrice :Math.round(r.finalPrice/r.fee*1000)/1000 ;
                r.cumulativePrice = r.finalPrice * r.balance;
                r.hasCustomBenefitAmount = x.CustomBenefitEnabled;
                r.customBenefitAmount = x.CustomBenefitAmount;
                r.isCustomBenefitSaved = true;
                return r;
            }));
            this.currentAllProductPriceSum = this.prices.reduce((s,c)=>s+c.balance*c.fee,0);
            this.calculatedPriceSum = this.prices.reduce((s,c)=>s+c.balance*c.calculablePrice,0);
            this.finalPriceSum = this.prices.reduce((s,c)=>s+c.balance*c.finalPrice,0);
            
            this.updateCumulative();
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    updateCumulative(){
        this.allNoSaleLockBalance = this.prices.reduce((s,c)=>s+c.noSaleLockAmount,0);
        this.allBalance = this.prices.reduce((s,c)=>s+c.balance,0);
        this.allHunt = this.prices.reduce((s,c)=>s+c.huntCount,0);
        this.allInWay = this.prices.reduce((s,c)=>s+c.inWay,0);
        this.allSale = this.prices.reduce((s,c)=>s+c.saleAmount,0);
        this.allCancel = this.prices.reduce((s,c)=>s+c.cancelAmount,0);
        this.allReturn = this.prices.reduce((s,c)=>s+c.returnAmount,0);
        this.allMarkaziSale = this.prices.reduce((s,c)=>s+c.markaziSoldAmount,0);
        this.allMellatSale = this.prices.reduce((s,c)=>s+c.mellatSoldAmount,0);
    
    }

    exportToExcel(){
        let converter = new Converters();
        let data = this.prices.map((x,i)=>{
            let result = {
                'ردیف':i+1,
                'کد فنی':x.productNo,
                'pnc':x.pnc,
                'برند':x.brand,
                'کشور':x.country,
                'رنگ':x.color,
                'نام':x.productName,
                'خودرو':x.carName,
                'مدل خودرو':x.carModels,
                'شناسه':x.productIndex,
                'موجودی':x.balance,
            };
            x.warehouseBalances.forEach(q=>{
                result[`موجودی ${q.warehouseName}`]=q.balance;
            })
            x.yearBalances.forEach(q=>{
                result[`موجودی ${q.year}`]=q.balance;
            })
            result['موجودی احتیاط']=x.noSaleLockAmount;
            result['موجودی احتیاط ملت']=x.mellatNoSaleLockAmount;
            result['موجودی احتیاط پرند']=x.parandNoSaleLockAmount;
            result['قیمت فروش']=x.lastSalePrice;
            result['هانت']=x.huntCount;
            result['خرید']=x.purchaseAmount;
            result['درراه']=x.inWay;
            result['آخرین قیمت واردات']=x.lastImportPrice;
            result['رقابتی']=x.isCompeting;
            result['min']=x.minImportPrice;
            result['max']=x.maxImportPrice;
            result['set']=x.setDollarPrice;
            result['تاریخ set']=converter.persianDateConverterNoTime(x.setPriceDate);
            result['دلار روز']=x.currentDollarPrice;
            result['فی']=x.fee;
            result['مقدار بهینه']=x.optimalTransferAmount;
            result['رزرو انبار']=x.balanceMargin;
            result['فروش']=x.saleAmount;
            result['برگشتی']=x.returnAmount;
            result['کنسلی']=x.cancelAmount;
            result['فروش انبار مرکزی']=x.markaziSoldAmount;
            result['فروش انبار ملت']=x.mellatSoldAmount;
            result['اندیس هانت']=converter.ConvertPricingIndexName(x.huntIndex);
            result['اندیس فروش']=converter.ConvertPricingIndexName(x.saleIndex);
            result['اندیس خرید']=converter.ConvertPricingIndexName(x.purchaseIndex);
            result['آخرین تاریخ جستجو']=converter.persianDateConverterNoTime(x.lastHuntTime);
            result['آخرین تاریخ فروش']=converter.persianDateConverterNoTime(x.lastSaleTime);
            result['آخرین تاریخ خرید']=converter.persianDateConverterNoTime(x.lastPurchaseTime);
            result['قیمت محاسباتی']=x.calculablePrice;
            result['قیمت نهایی']=x.finalPrice;
            result['روش محاسبه']=converter.ConvertPricingCalculationTypeName(x.calculationType);
            result['قیمت نهایی محاسبه اول']=x.firstRoundFinalPrice;
            result['روش محاسبه محاسبه اول']=converter.ConvertPricingCalculationTypeName(x.firstRoundCalculationType);
            result['سود درصد احتیاط'] = x.hasCustomBenefitAmount ? x.customBenefitAmount : 0;
            result['حداقل درصد احتیاط']=x.minBenefitPercentage;
            result['کاربر ویرایش کننده حداقل درصد احتیاط']=x.minBenefitModifier;
            result['تاریخ آخرین تغییر حداقل درصد احتیاط']=converter.persianDateConverterNoTime(x.minBenefitModifyDate);
            result['مبلغ موجودی']=x.cumulativePrice;
            result['اهمیت خرید']=x.importImportance;
            result['کالاهای معادل']=x.replacements;
            result['آخرین قیمت رقبا']={
                v:x.competitorPrice,
                t:'s',
                c:[{
                    a:'a',
                    t:x.inquiryInfo.map(x=>`(${x.competitorName} ${x.price} ${converter.persianDateConverterNoTime(x.time)} ${x.districtName})`).join('\r\n')
                }]
            };
            result['قیمت رقبا']=x.inquiryInfo.map(x=>`(${x.competitorName} ${x.price} ${converter.persianDateConverterNoTime(x.time)} ${x.districtName})`).join(' ');
            return result;
        });
        data.forEach(x=>x['آخرین قیمت رقبا'].c.hidden=true);
        new ExcelExporter().export('تنظیم قیمت.xlsx',data);
    }

    showPriceSummaryHistory(){
        this._parent.showPopup2(new priceSummaryHistory(this));
    }

    showSetPriceSummaryHistory(){
        this._parent.showPopup2(new setPriceHistoryReport(this));
    }
}

export class ApproachHistory extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set price(v: number) { this._price = v; } public get price(): number { return this._price;} private _price: number;
    public set approach(v: number) { this._approach = v; } public get approach(): number { return this._approach;} private _approach: number;
    public set benefit(v: number) { this._benefit = v; } public get benefit(): number { return this._benefit;} private _benefit: number;
    
}

export class singleProductPrice extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:AutomatedPriceUpdatingViewModel) {
        super(parent);
        this._parent = parent;
        this.isLoadingHistory = false;
        this.isApproachHistoryLoaded = false;
        this.saleHistory = ObservableArray.create<saleHistory>();
        this.purchaseHistory =  ObservableArray.create<purchaseHistory>();
        this.huntInfo =  ObservableArray.create<huntInfo>();
        this.priceHistory = ObservableArray.create<priceHistory>();
        this.inquiryInfo = ObservableArray.create<inquiryInfo>();
        this.warehouseBalances = ObservableArray.create<warehouseBalance>();
        this.importPrices = ObservableArray.create<ImportPrices>();
        this.saleFeeList = ObservableArray.create<RialFee>();
        this.yearBalances = ObservableArray.create<YearBalance>();
        this.customBenefitHistory = ObservableArray.create<benefitHistory>();
        this.approachHistoryList = ObservableArray.create<ApproachHistory>();
        this.cannotSet = !this._parent.isAdmin;
    }

    private _parent : AutomatedPriceUpdatingViewModel;

    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId;} private _productId: string;
    public set productNo(v: string) { this._productNo = v; } public get productNo(): string { return this._productNo;} private _productNo: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    
    public set pnc(v: string) { this._pnc = v; } public get pnc(): string { return this._pnc;} private _pnc: string;
    public set brand(v: string) { this._brand = v; } public get brand(): string { return this._brand;} private _brand: string;
    public set country(v: string) { this._country = v; } public get country(): string { return this._country;} private _country: string;
    public set color(v: string) { this._color = v; } public get color(): string { return this._color;} private _color: string;
    public set productIndex(v: string) { this._productIndex = v; } public get productIndex(): string { return this._productIndex;} private _productIndex: string;
    
    public set replacements(v: string) { this._replacements = v; } public get replacements(): string { return this._replacements;} private _replacements: string;
    public set carModels(v: string) { this._carModels = v; } public get carModels(): string { return this._carModels;} private _carModels: string;
    public set hasReplacements(v: boolean) { this._hasReplacements = v; } public get hasReplacements(): boolean { return this._hasReplacements;} private _hasReplacements: boolean;
    public set hasCarModels(v: boolean) { this._hasCarModels = v; } public get hasCarModels(): boolean { return this._hasCarModels;} private _hasCarModels: boolean;
    public set car(v: string) { this._car = v; } public get car(): string { return this._car;} private _car: string;
    public set carName(v: string) { this._carName = v; } public get carName(): string { return this._carName;} private _carName: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance;} private _balance: number;
    public set balanceMargin(v: number) { this._balanceMargin = v; } public get balanceMargin(): number { return this._balanceMargin;} private _balanceMargin: number;
    public set noSaleLockAmount(v: number) { this._noSaleLockAmount = v; } public get noSaleLockAmount(): number { return this._noSaleLockAmount;} private _noSaleLockAmount: number;
    public set mellatNoSaleLockAmount(v: number) { this._mellatNoSaleLockAmount = v; } public get mellatNoSaleLockAmount(): number { return this._mellatNoSaleLockAmount;} private _mellatNoSaleLockAmount: number;
    public set parandNoSaleLockAmount(v: number) { this._parandNoSaleLockAmount = v; } public get parandNoSaleLockAmount(): number { return this._parandNoSaleLockAmount;} private _parandNoSaleLockAmount: number;
    
    public set lastSalePrice(v: number) { this._lastSalePrice = v; } public get lastSalePrice(): number { return this._lastSalePrice;} private _lastSalePrice: number;
    public set huntCount(v: number) { this._huntCount = v; } public get huntCount(): number { return this._huntCount;} private _huntCount: number;
    public set purchaseAmount(v: number) { this._purchaseAmount = v; } public get purchaseAmount(): number { return this._purchaseAmount;} private _purchaseAmount: number;
    public set inWay(v: number) { this._inWay = v; } public get inWay(): number { return this._inWay;} private _inWay: number;
    public set fee(v: number) { this._fee = v; } public get fee(): number { return this._fee;} private _fee: number;
    public set calculablePrice(v: number) { this._calculablePrice = v; } public get calculablePrice(): number { return this._calculablePrice;} private _calculablePrice: number;
    public set competitorPrice(v: number) { this._competitorPrice = v; } public get competitorPrice(): number { return this._competitorPrice;} private _competitorPrice: number;
    public set setDollarPrice(v: number) { 
        this._setDollarPrice = utilities.getAsNumber(v);
        this.updateCalculablePrice();
        this.isSetSaved = false;
    } public get setDollarPrice(): number { return this._setDollarPrice;} private _setDollarPrice: number;
    public set setPriceDate(v: moment.Moment) { this._setPriceDate = v; } public get setPriceDate(): moment.Moment { return this._setPriceDate;} private _setPriceDate: moment.Moment;
    public set isSetPriceEditable(v: boolean) { this._isSetPriceEditable = v; } public get isSetPriceEditable(): boolean { 
        if (this.cannotSet == true) return false;
        return this._isSetPriceEditable;} private _isSetPriceEditable: boolean;
    public set isCompeting(v: boolean) { 
        this._isCompeting = v;
        this.isCompetingSaved = false;
    } public get isCompeting(): boolean { return this._isCompeting;} private _isCompeting: boolean;
    public set isSetSaved(v: boolean) { this._isSetSaved = v; } public get isSetSaved(): boolean { return this._isSetSaved;} private _isSetSaved: boolean;
    public set isCompetingSaved(v: boolean) { this._isCompetingSaved = v; } public get isCompetingSaved(): boolean { return this._isCompetingSaved;} private _isCompetingSaved: boolean;
    public set saleHistory(v: ObservableArray<saleHistory>) { this._saleHistory = v; } public get saleHistory(): ObservableArray<saleHistory> { return this._saleHistory;} private _saleHistory: ObservableArray<saleHistory>;
    public set purchaseHistory(v: ObservableArray<purchaseHistory>) { this._purchaseHistory = v; } public get purchaseHistory(): ObservableArray<purchaseHistory> { return this._purchaseHistory;} private _purchaseHistory: ObservableArray<purchaseHistory>;
    public set huntInfo(v: ObservableArray<huntInfo>) { this._huntInfo = v; } public get huntInfo(): ObservableArray<huntInfo> { return this._huntInfo;} private _huntInfo: ObservableArray<huntInfo>;
    public set priceHistory(v: ObservableArray<priceHistory>) { this._priceHistory = v; } public get priceHistory(): ObservableArray<priceHistory> { return this._priceHistory;} private _priceHistory: ObservableArray<priceHistory>;
    public set inquiryInfo(v: ObservableArray<inquiryInfo>) { this._inquiryInfo = v; } public get inquiryInfo(): ObservableArray<inquiryInfo> { return this._inquiryInfo;} private _inquiryInfo: ObservableArray<inquiryInfo>;
    public set optimalTransferAmount(v: number) { this._optimalTransferAmount = v; } public get optimalTransferAmount(): number { return this._optimalTransferAmount;} private _optimalTransferAmount: number;
    public set mellatSoldAmount(v: number) { this._mellatSoldAmount = v; } public get mellatSoldAmount(): number { return this._mellatSoldAmount;} private _mellatSoldAmount: number;
    public set markaziSoldAmount(v: number) { this._markaziSoldAmount = v; } public get markaziSoldAmount(): number { return this._markaziSoldAmount;} private _markaziSoldAmount: number;
    public set saleAmount(v: number) { this._saleAmount = v; } public get saleAmount(): number { return this._saleAmount;} private _saleAmount: number;
    public set cancelAmount(v: number) { this._cancelAmount = v; } public get cancelAmount(): number { return this._cancelAmount;} private _cancelAmount: number;
    public set returnAmount(v: number) { this._returnAmount = v; } public get returnAmount(): number { return this._returnAmount;} private _returnAmount: number;
    public set importImportance(v: number) { this._importImportance = utilities.getAsNumber(v); } public get importImportance(): number { return this._importImportance;} private _importImportance: number;
    public set warehouseBalances(v: ObservableArray<warehouseBalance>) { this._warehouseBalances = v; } public get warehouseBalances(): ObservableArray<warehouseBalance> { return this._warehouseBalances;} private _warehouseBalances: ObservableArray<warehouseBalance>;
    public set lastImportPrice(v: number) { this._lastImportPrice = v; } public get lastImportPrice(): number { return this._lastImportPrice;} private _lastImportPrice: number;
    public set importPrices(v: ObservableArray<ImportPrices>) { this._importPrices = v; } public get importPrices(): ObservableArray<ImportPrices> { return this._importPrices;} private _importPrices: ObservableArray<ImportPrices>;
    public set saleFeeList(v: ObservableArray<RialFee>) { this._saleFeeList = v; } public get saleFeeList(): ObservableArray<RialFee> { return this._saleFeeList;} private _saleFeeList: ObservableArray<RialFee>;
    public set currentDollarPrice(v: number) { this._currentDollarPrice = v; } public get currentDollarPrice(): number { return this._currentDollarPrice;} private _currentDollarPrice: number;
    public set minImportPrice(v: number) { this._minImportPrice = v; } public get minImportPrice(): number { return this._minImportPrice;} private _minImportPrice: number;
    public set minBenefitPercentage(v: number) { this._minBenefitPercentage = v; } public get minBenefitPercentage(): number { return this._minBenefitPercentage;} private _minBenefitPercentage: number;
    public set minBenefitModifyDate(v: moment.Moment) { this._minBenefitModifyDate = v; } public get minBenefitModifyDate(): moment.Moment { return this._minBenefitModifyDate;} private _minBenefitModifyDate: moment.Moment;
    public set minBenefitModifier(v: string) { this._minBenefitModifier = v; } public get minBenefitModifier(): string { return this._minBenefitModifier;} private _minBenefitModifier: string;
    public set maxImportPrice(v: number) { this._maxImportPrice = v; } public get maxImportPrice(): number { return this._maxImportPrice;} private _maxImportPrice: number;
    public set minImportPriceTime(v: moment.Moment) { this._minImportPriceTime = v; } public get minImportPriceTime(): moment.Moment { return this._minImportPriceTime;} private _minImportPriceTime: moment.Moment;
    public set maxImportPriceTime(v: moment.Moment) { this._maxImportPriceTime = v; } public get maxImportPriceTime(): moment.Moment { return this._maxImportPriceTime;} private _maxImportPriceTime: moment.Moment;
    public set customBenefitHistory(v: ObservableArray<benefitHistory>) { this._customBenefitHistory = v; } public get customBenefitHistory(): ObservableArray<benefitHistory> { return this._customBenefitHistory;} private _customBenefitHistory: ObservableArray<benefitHistory>;
    public set approachHistoryList(v: ObservableArray<ApproachHistory>) { this._approachHistoryList = v; } public get approachHistoryList(): ObservableArray<ApproachHistory> { return this._approachHistoryList;} private _approachHistoryList: ObservableArray<ApproachHistory>;
    
    public set hasCustomBenefitAmount(v: boolean) { 
        this._hasCustomBenefitAmount = v; 
        this.isCustomBenefitSaved = false;
    } public get hasCustomBenefitAmount(): boolean { return this._hasCustomBenefitAmount;} private _hasCustomBenefitAmount: boolean;
    public set customBenefitAmount(v: number) { 
        this._customBenefitAmount =utilities.getAsNumber(v); 
        this.isCustomBenefitSaved = false;
    } public get customBenefitAmount(): number { return this._customBenefitAmount;} private _customBenefitAmount: number;
    public set isCustomBenefitSaved(v: boolean) { this._isCustomBenefitSaved = v; } public get isCustomBenefitSaved(): boolean { 
        if (this.cannotSet == true) return true;
        return this._isCustomBenefitSaved;} private _isCustomBenefitSaved: boolean;
    

    public set huntIndex(v: number) { this._huntIndex = v; } public get huntIndex(): number { return this._huntIndex;} private _huntIndex: number;
    public set saleIndex(v: number) { this._saleIndex = v; } public get saleIndex(): number { return this._saleIndex;} private _saleIndex: number;
    public set purchaseIndex(v: number) { this._purchaseIndex = v; } public get purchaseIndex(): number { return this._purchaseIndex;} private _purchaseIndex: number;
    
    public set lastHuntTime(v: moment.Moment) { this._lastHuntTime = v; } public get lastHuntTime(): moment.Moment { return this._lastHuntTime;} private _lastHuntTime: moment.Moment;
    public set lastSaleTime(v: moment.Moment) { this._lastSaleTime = v; } public get lastSaleTime(): moment.Moment { return this._lastSaleTime;} private _lastSaleTime: moment.Moment;
    public set lastPurchaseTime(v: moment.Moment) { this._lastPurchaseTime = v; } public get lastPurchaseTime(): moment.Moment { return this._lastPurchaseTime;} private _lastPurchaseTime: moment.Moment;
    

    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice;} private _finalPrice: number;
    public set calculationType(v: number) { this._calculationType = v; } public get calculationType(): number { return this._calculationType;} private _calculationType: number;
    public set firstRoundFinalPrice(v: number) { this._firstRoundFinalPrice = v; } public get firstRoundFinalPrice(): number { return this._firstRoundFinalPrice;} private _firstRoundFinalPrice: number;
    public set firstRoundCalculationType(v: number) { this._firstRoundCalculationType = v; } public get firstRoundCalculationType(): number { return this._firstRoundCalculationType;} private _firstRoundCalculationType: number;
    public set priceRelation(v: number) { this._priceRelation = v; } public get priceRelation(): number { return this._priceRelation;} private _priceRelation: number;
    
    public set changeAmount(v: number) { this._changeAmount = v; } public get changeAmount(): number { return this._changeAmount;} private _changeAmount: number;
    public set changeRatio(v: number) { this._changeRatio = v; } public get changeRatio(): number { return this._changeRatio;} private _changeRatio: number;
    public set cumulativePrice(v: number) { this._cumulativePrice = v; } public get cumulativePrice(): number { return this._cumulativePrice;} private _cumulativePrice: number;
    
    public set yearBalances(v: ObservableArray<YearBalance>) { this._yearBalances = v; } public get yearBalances(): ObservableArray<YearBalance> { return this._yearBalances;} private _yearBalances: ObservableArray<YearBalance>;
    public set lastInquiryPrice(v: number) { this._lastInquiryPrice = v; } public get lastInquiryPrice(): number { return this._lastInquiryPrice;} private _lastInquiryPrice: number;
    
    public set isLoaded(v: boolean) { this._isLoaded = v; } public get isLoaded(): boolean { return this._isLoaded;} private _isLoaded: boolean;
    public set isLoadingHistory(v: boolean) { this._isLoadingHistory = v; } public get isLoadingHistory(): boolean { return this._isLoadingHistory;} private _isLoadingHistory: boolean;
    
    public set isApproachHistoryLoaded(v: boolean) { this._isApproachHistoryLoaded = v; } public get isApproachHistoryLoaded(): boolean { return this._isApproachHistoryLoaded;} private _isApproachHistoryLoaded: boolean;
    public set cannotSet(v: boolean) { this._cannotSet = v; } public get cannotSet(): boolean { return this._cannotSet;} private _cannotSet: boolean;
    
    async loadApproachHistory(){
        try {
            this.isLoadingHistory = true;
            let result = await ServerConnection.callServer('/Complex/PricingServices/GetPricingApproachHistory',{
                ProductId:this.productId,
                Count:10
            });
            this.approachHistoryList.update(...result.History.map(x=>{
                let r = new ApproachHistory(this);
                r.time = moment.utc(x.Time);
                r.approach = x.Approach;
                r.price = x.Price;
                r.benefit = x.Benefit;
                return r;
            }))
            this.isApproachHistoryLoaded = true;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoadingHistory = false;
        }
    }
    async setPrice(){
        try {
            if (this.isSetPriceEditable == false) {
                let result = await this.messageBoxWarningYesNo("آخرین خرید کمتر از یک ماه است. آیا مطمئنید؟ ","ثبت قیمت");
                if(result=='no'){
                    return;
                }
            }
            await ServerConnection.callServer('Complex/PricingServices/SetProductDollarPrice',{
                ProductId:this.productId,
                Price:this.setDollarPrice
            });
            this.isSetSaved = true;
        } catch (ex) {
            console.log(ex);
        } finally {
        }
    }
    async setCompeting(){
        try {
            if (this.isSetPriceEditable == false) {
                let result = await this.messageBoxWarningYesNo("آخرین خرید کمتر از یک ماه است. آیا مطمئنید؟ ","ثبت قیمت");
                if(result=='no'){
                    return;
                }
            }
            await ServerConnection.callServer('Complex/PricingServices/SetCompeting',{
                ProductId:this.productId,
                IsCompeting:this.isCompeting
            });
            this.isCompetingSaved = true;
        } catch (ex) {
            console.log(ex);
        } finally {
        }
    }
    async setCustomBenefit(){
        try {
            await ServerConnection.callServer('Complex/PricingServices/SetProductCustomBenefit',{
                ProductId:this.productId,
                BenefitAmount:this.customBenefitAmount,
                IsEnabled:this.hasCustomBenefitAmount
            });
            this.isCustomBenefitSaved = true;
        } catch (ex) {
            console.log(ex);
        } finally {
        }
    }
    async setSingleProductPrice(){
        try {
            let result = await ServerConnection.callServer('/Complex/PricingServices/SetProductPricesBatch',{
                Prices:[{
                        ProductId:this.productId,
                        PriceAmount:this.finalPrice,
                        From:null,
                        ApproachType:this.calculationType,
                        CustomPercentage:this.customBenefitAmount

                    }
                ]
            })
            if(result.IsSuccessful)
                alert('عملیات با موفقیت انجام شد.');
            else
                alert('خطا در انجام عملیات')
        } catch (ex) {
            alert('خطا در انجام عملیات')
            console.log(ex);
        } finally {
        }
    }
    updateCalculablePrice() {
        this.calculablePrice = this.setDollarPrice * 1.2 * 1.3 * this.currentDollarPrice;
    }
    
    async setImportance(){
        try {
            await ServerConnection.callServer('Complex/PricingServices/UpdateImportingImportance',{
                ProductId:this.productId,
                Importance:this.importImportance
            });
        } catch (ex) {
            console.log(ex);
        } finally {
        }
    }
}
export class RialFee extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set fee(v: number) { this._fee = v; } public get fee(): number { return this._fee;} private _fee: number;
}
export class ImportPrices extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set supplierName(v: string) { this._supplierName = v; } public get supplierName(): string { return this._supplierName;} private _supplierName: string;
    public set price(v: number) { this._price = v; } public get price(): number { return this._price;} private _price: number;
    
}
export class saleHistory extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set count(v: number) { this._count = v; } public get count(): number { return this._count;} private _count: number;
    public set fee(v: number) { this._fee = v; } public get fee(): number { return this._fee;} private _fee: number;
    public set benefitPercentage(v: number) { this._benefitPercentage = v; } public get benefitPercentage(): number { return this._benefitPercentage;} private _benefitPercentage: number;
    public set systemBenefitPercentage(v: number) { this._systemBenefitPercentage = v; } public get systemBenefitPercentage(): number { return this._systemBenefitPercentage;} private _systemBenefitPercentage: number;
    public set setPrice(v: number) { this._setPrice = v; } public get setPrice(): number { return this._setPrice;} private _setPrice: number;
    public set dollarPrice(v: number) { this._dollarPrice = v; } public get dollarPrice(): number { return this._dollarPrice;} private _dollarPrice: number;

}

export class inquiryInfo extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set competitorName(v: string) { this._competitorName = v; } public get competitorName(): string { return this._competitorName;} private _competitorName: string;
    public set price(v: number) { this._price = v; } public get price(): number { return this._price;} private _price: number;
}

export class purchaseHistory extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set count(v: number) { this._count = v; } public get count(): number { return this._count;} private _count: number;
    public set fee(v: number) { this._fee = v; } public get fee(): number { return this._fee;} private _fee: number;
    
}
export class priceHistory extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }

    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    public set setPrice(v: number) { this._setPrice = v; } public get setPrice(): number { return this._setPrice;} private _setPrice: number;
    public set updater(v: string) { this._updater = v; } public get updater(): string { return this._updater;} private _updater: string;
}

export class huntInfo extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set count(v: number) { this._count = v; } public get count(): number { return this._count;} private _count: number;
}
export class warehouseBalance extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance;} private _balance: number;
}
export class priceSummaryItem extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set dollarPrice(v: number) { this._dollarPrice = v; } public get dollarPrice(): number { return this._dollarPrice;} private _dollarPrice: number;
    public set finalCalculablePrice(v: number) { this._finalCalculablePrice = v; } public get finalCalculablePrice(): number { return this._finalCalculablePrice;} private _finalCalculablePrice: number;
    public set finalCurrentPrice(v: number) { this._finalCurrentPrice = v; } public get finalCurrentPrice(): number { return this._finalCurrentPrice;} private _finalCurrentPrice: number;
    public set finalTotalPrice(v: number) { this._finalTotalPrice = v; } public get finalTotalPrice(): number { return this._finalTotalPrice;} private _finalTotalPrice: number;
    public set productCount(v: number) { this._productCount = v; } public get productCount(): number { return this._productCount;} private _productCount: number;
    
    
}
export class priceSummaryHistory extends ViewModel{
    public getTypeId(): string {return 'priceupdatingsummaryreport';}
    public GetDefaultView(): View<ViewModel> {return null;}
    private _parentUpdatingViewModel:AutomatedPriceUpdatingViewModel;

    constructor(parent:AutomatedPriceUpdatingViewModel) {
        super(parent);
        this._parentUpdatingViewModel = parent;
        this.items = ObservableArray.create<priceSummaryItem>();    
        this.refresh();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<priceSummaryItem>) { this._items = v; } public get items(): ObservableArray<priceSummaryItem> { return this._items;} private _items: ObservableArray<priceSummaryItem>;
    
    async refresh(){
        try {
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/PricingServices/GetAllSummaries',{});
            this.items.update(...result.Summaries.map(x=>{
                let r = new priceSummaryItem(this);
                r.time = moment.utc(x.Time);
                r.dollarPrice = x.DollarPrice;
                r.finalCalculablePrice = x.FinalCalculablePrice;
                r.finalCurrentPrice = x.FinalCurrentPrice;
                r.finalTotalPrice = x.FinalTotalPrice;
                r.productCount = x.ProductCount;
                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    close(){
        this._parentUpdatingViewModel.closePopup();
    }
}

export class dollarFeeSetting extends ViewModel{
    public getTypeId(): string {return 'priceupdatingdollarfee';}
    public GetDefaultView(): View<ViewModel> {return null;}
    private _parentViewModel:AutomatedPriceUpdatingViewModel;
    constructor(parent:AutomatedPriceUpdatingViewModel) {
        super(parent);
        this.feeList = ObservableArray.create<singleDollarFee>();
        this._parentViewModel = parent;
        this.refresh();
    }
    
    public set feeList(v: ObservableArray<singleDollarFee>) { this._feeList = v; } public get feeList(): ObservableArray<singleDollarFee> { return this._feeList;} private _feeList: ObservableArray<singleDollarFee>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set newFee(v: number) { this._newFee =utilities.getAsNumber(v); } public get newFee(): number { return this._newFee;} private _newFee: number;
    
    async refresh(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/PricingServices/GetAllDollarPrices',{
                CarModelId: this._parentViewModel.car
            });
            this.feeList.update(...result.Prices.map(x=>{
                let r= new singleDollarFee(this);
                r.from = moment.utc(x.From);
                r.until = x.Until==null ? null : moment.utc(x.Until);
                r.fee = x.Price;
                return r;
            }))          
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async confirmNewFee(){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('Complex/PricingServices/SetDollarPrice',{
                Price:this.newFee,
                CarModelId: this._parentViewModel.car
            });
            this.refresh();
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    close(){
        this._parentViewModel.closePopup();
    }
}


export class singleDollarFee extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    public set fee(v: number) { this._fee = v; } public get fee(): number { return this._fee;} private _fee: number;
    
}

export class indexEnumProvider extends Enum implements IEnumTranslator{
    private converter:Converters;
    constructor() {
        super();
        this.converter = new Converters();
        this.values = [1,2,3,4,5,6,7,8,9,10,12];
        this.translator = this;        
    }
    GetString(value: any) {
        return this.converter.ConvertPricingIndexName(value);
    }
}

export class calculationTypeProvider extends Enum implements IEnumTranslator{
    private converter:Converters;
    constructor() {
        super();
        this.converter = new Converters();
        this.values = [1,2,
            20,
            21,22,23,24,25,26,
            300,301,302,303,304,305,306,307,308,309,
            400,401,402,403,404,405,406,407,408,409,
            500,501,502,503,504,505,506,507,508,509,
            6];
        this.translator = this;        
    }
    GetString(value: any) {
        return this.converter.ConvertPricingCalculationTypeName(value);
    }
}

export class YearBalance extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set year(v: number) { this._year = v; } public get year(): number { return this._year;} private _year: number;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance;} private _balance: number;
    
}

export class setPriceHistoryReport extends ViewModel{
    public getTypeId(): string {return 'priceupdatingsetpricehistory';}
    public GetDefaultView(): View<ViewModel> {return null;}
    private _parentvm:AutomatedPriceUpdatingViewModel;

    constructor(parent:AutomatedPriceUpdatingViewModel) {
        super(parent);
        this.items = ObservableArray.create<priceHistoryLine>();
        this._parentvm = parent;
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    public set items(v: ObservableArray<priceHistoryLine>) { this._items = v; } public get items(): ObservableArray<priceHistoryLine> { return this._items;} private _items: ObservableArray<priceHistoryLine>;
    

    async load(){
        try {
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/PricingServices/GetSettedPriceHistory',{
                From: this.from.clone().hour(5).minute(0).second(0),
                Until: this.until.clone().hour(5).minute(0).second(0)
            });
            this.items.update(...result.Prices.map(x=>{
                let r = new priceHistoryLine(this);
                r.brand = x.Brand;
                r.pnc = x.Pnc;
                r.name = x.Name;
                r.time = moment.utc(x.Time);
                r.price = x.Price;
                return r;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    close(){
        this._parentvm.closePopup();
    }
}

export class priceHistoryLine extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set brand(v: string) { this._brand = v; } public get brand(): string { return this._brand;} private _brand: string;
    public set pnc(v: string) { this._pnc = v; } public get pnc(): string { return this._pnc;} private _pnc: string;
    public set price(v: number) { this._price = v; } public get price(): number { return this._price;} private _price: number;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    
}

export class priceRelation extends Enum implements IEnumTranslator{
    constructor() {
        super();
        this.values = [0,1,2]
        this.translator = this;        
    }
    GetString(value: any) {
        return new Converters().ConvertPriceToInquiryPriceRelation(value);
    }

}

export class benefitHistory extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set applier(v: string) { this._applier = v; } public get applier(): string { return this._applier;} private _applier: string;
    
}
